import { Helmet } from "react-helmet-async";
import { useProductStore } from "@/store/product";

type SEOProps = {
  description?: string;
  meta?: { name: string; content: string }[];
  title?: string;
};

export default function SEO({ description, meta = [], title }: SEOProps) {
  const metaDescription =
    description || "Compre um plano da TIM com a facilidade que só a TIM tem.";
  const item = useProductStore((store) => store.item);
  const isPos = useProductStore((store) => store.isPos);
  const isExpress = useProductStore((store) => store.isExpress);

  const titleSegment = isPos() ? "Pós" : isExpress() ? "Express" : "Controle";

  const titleFull = title + (item ? ` | ${titleSegment}` : "");

  return (
    <Helmet
      htmlAttributes={{ lang: "pt-br" }}
      title={titleFull}
      titleTemplate={`%s | TIM E-commerce`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ].concat(meta)}
    >
      {/*<html lang='pt' />*/}
    </Helmet>
  );
}
